import styled from 'styled-components';
import { ModalSubmitButton } from '../../Clients/modals/CreateAndUpdateClientModal.styles';

export {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FooterActions,
  ModalCancelButton,
  InputLabel,
  TextInput,
} from '../../Clients/modals/CreateAndUpdateClientModal.styles';

export const ConfirmText = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.normal};
  line-height: 1.5;
  color: ${({ theme }) => theme.landing.textSecondary};

  strong {
    font-weight: 600;
    color: ${({ theme }) => theme.landing.text};
    word-break: break-word;
  }
`;

export const ConfirmKeyword = styled.span`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  color: ${({ theme }) => theme.landing.text};
  background: ${({ theme }) => theme.landing.iconBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: 1px 6px;
`;

// Destructive variant of the shared submit button
export const ConfirmCloseButton = styled(ModalSubmitButton)`
  background: ${({ theme }) => theme.landing.errorColor};
  border-color: ${({ theme }) => theme.landing.errorColor};

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.landing.errorColor};
    border-color: ${({ theme }) => theme.landing.errorColor};
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.sm};
`;
